<template>
  <div>
    <span class="usa-error-message">{{ error.data.message }}</span>
  </div>
</template>

<script>
export default {
  name: "MarcError",
  props: {
    error: Object
  }
}
</script>
